import React from "react";
import FlowMode from "@/models/enums/flow-mode.ts";
import ProjectCreationModel from "../models/project-creation-model.ts";

export interface ProjectCreationContextProps {
    flowModeCreationProject: FlowMode | undefined;
    setFlowModeCreationProject: (flowMode: FlowMode | undefined) => void;

    data: ProjectCreationModel;
    setProjectInformations: (name: string, localisationId: number) => ProjectCreationModel;
    
    currentFiles: File[];
    storeyHeight: number;
    analyseFileNames: (files: File[], storeyHeight: number, forceSingleBuilding?: boolean) => ProjectCreationModel;
    
    isCreatingProject: boolean;
    creatingProjectPhase: string | React.ReactNode;
    createProject: (creationModelOverride?: ProjectCreationModel) => void;
}

export const ProjectCreationContext = React.createContext<ProjectCreationContextProps | undefined>(undefined);